import { ZealApiSuccessResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPutRecentlyViewedPagesArgs,
  IPutRecentlyViewedPagesResponseData,
} from "./putRecentlyViewedPages.schema";

type SuccessResponse =
  ZealApiSuccessResponse<IPutRecentlyViewedPagesResponseData>;

export const putRecentlyViewedPages = (axios: IAxiosInstance) => {
  return async (params: IPutRecentlyViewedPagesArgs) => {
    try {
      const response = await axios.noRetry.put<SuccessResponse>(
        "/api/recently-viewed-pages",
        params
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
